import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { MapStateToPropsFactory, MapDispatchToProps } from "react-redux";
import { BetslipStep } from "@ppb/tbd-store/state/betslip/Betslip.types";
import type { ExchangeBetslipContract } from "../../contract";

export type StateProps = {
  step: BetslipStep;
};

export type ContainerProps = {
  contract: ExchangeBetslipContract;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps | false, ContainerProps, BetslipApplicationState> =
  () => (appState: BetslipApplicationState) => {
    const step = appState.betslipModule?.step;

    if (!step) {
      return false;
    }

    return { step };
  };

export type DispatchProps = Record<string, never>;

export const mapDispatchToProps: MapDispatchToProps<DispatchProps, ContainerProps> = () => ({});
